import { AccessTimeRounded } from '@mui/icons-material';
import { Box, Link, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { defaultRequestStatusLightColor, requestStatusLightColors, requestStatusMobileIcons } from '.';
import { NavLinkComponent } from '../../Router';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { Request } from '../../models/Types';

const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildRequestListItem(x: Request) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'request'], ['id', x.Id]]}>
        <Box display="flex" flexDirection="column" minWidth={80} gap={.5}>
            <Link variant="h3">№{x.Id}</Link>
            <Typography variant="body4">{moment(x.CreateDate).format('DD.MM.yy')}</Typography>
        </Box>
        <Box flex={1}>
            <Typography variant="h3" textAlign="left">{x.Name}</Typography>
        </Box>
        <Box sx={x.Status ? { ...styles.mobileIconWrapper, bgcolor: requestStatusLightColors[x.Status] || defaultRequestStatusLightColor } : styles.mobileIconWrapper}>
            {x.Status && requestStatusMobileIcons[x.Status] ? requestStatusMobileIcons[x.Status]() : <AccessTimeRounded color="warning" fontSize="small" />}
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Заявок пока нет" content={['В этом разделе вы можете создавать заявки к УК на оказание услуг']} />;
}

export default class RequestList extends DataListComponent<Request> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: Request, i: number) {
        return buildRequestListItem(x);
    }
}